/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from "react";

import YesNoAction from "../../../../components/YesNoAction";
import TestIds from "../../../../testIds";
import { URLS } from "../../../../util/consts";
import { OrderListContainer } from "../../../orders/OrderList";
import { Quote } from "../../storage/types";

import QuoteCard from "./QuoteCard";

interface QuoteListProps {
  data: Quote[] | null;
}

const QuoteList = ({ data }: QuoteListProps) => {
  function onClickFindStore() {
    window.open(URLS.findStore, "_blank");
  }

  if (!data) {
    return (
      <div data-testid={TestIds.feat.quotes.list.noQuotes}>
        <YesNoAction
          body="You do not currently have any quotes to display. Your quote will be displayed here once you have submitted a quote to Farmlands."
          optionA={{
            label: "Find a store",
            onClick: onClickFindStore,
          }}
        />
      </div>
    );
  }
  return (
    <OrderListContainer>
      {data.map((x) => (
        <QuoteCard data={x} key={x.id} />
      ))}
    </OrderListContainer>
  );
};

export default QuoteList;
